// App Configuration
export const APP_NAME = 'AxiomVanta ERP';
export const APP_VERSION = '1.0.0';

// API Configuration
export const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8080';
export const API_VERSION = import.meta.env.VITE_API_VERSION || 'v1';
export const API_TIMEOUT = 30000; // 30 seconds

// Pagination
export const DEFAULT_PAGE_SIZE = 20;
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

// Date Formats
export const DATE_FORMAT = 'dd/MM/yyyy';
export const DATETIME_FORMAT = 'dd/MM/yyyy HH:mm';
export const API_DATE_FORMAT = 'yyyy-MM-dd';

// Australian States
export const AUSTRALIAN_STATES = [
  { code: 'NSW', name: 'New South Wales' },
  { code: 'VIC', name: 'Victoria' },
  { code: 'QLD', name: 'Queensland' },
  { code: 'WA', name: 'Western Australia' },
  { code: 'SA', name: 'South Australia' },
  { code: 'TAS', name: 'Tasmania' },
  { code: 'ACT', name: 'Australian Capital Territory' },
  { code: 'NT', name: 'Northern Territory' },
] as const;

// GST Rate
export const GST_RATE = 0.10; // 10%

// Currency
export const DEFAULT_CURRENCY = 'AUD';
export const CURRENCY_SYMBOL = '$';

// Tax Year (Australia: July 1 - June 30)
export const TAX_YEAR_START_MONTH = 6; // July (0-indexed)
export const TAX_YEAR_START_DAY = 1;

// Contact Types
export const CONTACT_TYPES = [
  { value: 'customer', label: 'Customer' },
  { value: 'supplier', label: 'Supplier' },
  { value: 'employee', label: 'Employee' },
  { value: 'contractor', label: 'Contractor' },
  { value: 'other', label: 'Other' },
] as const;

// Invoice Status
export const INVOICE_STATUSES = [
  { value: 'draft', label: 'Draft', color: 'gray' },
  { value: 'sent', label: 'Sent', color: 'blue' },
  { value: 'viewed', label: 'Viewed', color: 'purple' },
  { value: 'partial', label: 'Partially Paid', color: 'orange' },
  { value: 'paid', label: 'Paid', color: 'green' },
  { value: 'overdue', label: 'Overdue', color: 'red' },
  { value: 'cancelled', label: 'Cancelled', color: 'gray' },
] as const;

// Payment Terms
export const PAYMENT_TERMS = [
  { value: 'immediate', label: 'Immediate', days: 0 },
  { value: 'net_7', label: 'Net 7 days', days: 7 },
  { value: 'net_14', label: 'Net 14 days', days: 14 },
  { value: 'net_30', label: 'Net 30 days', days: 30 },
  { value: 'net_60', label: 'Net 60 days', days: 60 },
  { value: 'net_90', label: 'Net 90 days', days: 90 },
] as const;

// Account Types (Chart of Accounts)
export const ACCOUNT_TYPES = [
  { value: 'asset', label: 'Asset', category: 'balance_sheet' },
  { value: 'liability', label: 'Liability', category: 'balance_sheet' },
  { value: 'equity', label: 'Equity', category: 'balance_sheet' },
  { value: 'revenue', label: 'Revenue', category: 'income_statement' },
  { value: 'expense', label: 'Expense', category: 'income_statement' },
] as const;

// Local Storage Keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'ss_auth_token',
  REFRESH_TOKEN: 'ss_refresh_token',
  USER: 'ss_user',
  ORGANIZATION: 'ss_organization',
  THEME: 'ss_theme',
  SIDEBAR_COLLAPSED: 'ss_sidebar_collapsed',
} as const;

// Error Messages
export const ERROR_MESSAGES = {
  GENERIC: 'An unexpected error occurred. Please try again.',
  NETWORK: 'Network error. Please check your connection.',
  UNAUTHORIZED: 'Your session has expired. Please log in again.',
  FORBIDDEN: 'You do not have permission to perform this action.',
  NOT_FOUND: 'The requested resource was not found.',
  VALIDATION: 'Please check your input and try again.',
} as const;

// Success Messages
export const SUCCESS_MESSAGES = {
  SAVED: 'Changes saved successfully.',
  CREATED: 'Record created successfully.',
  UPDATED: 'Record updated successfully.',
  DELETED: 'Record deleted successfully.',
  EMAIL_SENT: 'Email sent successfully.',
  INVITED: 'Invitation sent successfully.',
} as const;

// Tax Codes (Australian GST)
export const TAX_CODES = [
  { value: 'GST', label: 'GST (10%)', rate: 0.10 },
  { value: 'GST_FREE', label: 'GST Free', rate: 0 },
  { value: 'INPUT_TAXED', label: 'Input Taxed', rate: 0 },
  { value: 'EXPORT', label: 'Export (0%)', rate: 0 },
] as const;

// Validation Rules
export const VALIDATION = {
  EMAIL_MAX_LENGTH: 255,
  PASSWORD_MIN_LENGTH: 8,
  NAME_MAX_LENGTH: 100,
  PHONE_MAX_LENGTH: 20,
  ABN_LENGTH: 11,
  ACN_LENGTH: 9,
  DESCRIPTION_MAX_LENGTH: 1000,
} as const;
